import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { penTypes } from '../../../Definitions/valueTypes'
import { colors, glyphs } from '../../../Styles'

import { Button, ButtonList, PEN_EDIT } from '../..'
import { ButtonTypes } from '../../../Definitions'
import { BaseSection } from './_Section/interface'
import { useAppSelector } from '../../../Store'
import { Graph_QL } from '../../../Services'
import { useAnimal } from '../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal'
import { PanelMaintainAnimal } from '../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/maintainAnimalInfoCall'
import { useSection } from '../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections'

interface Section_Props extends BaseSection {
  onSaveBtn?: () => void
  onCancelBtn?: () => void
  sectionId: number
}
/**
 * SECTION_EDIT
 * @param sectionId Unique identifier for each section.
 * @param onSaveBtn OnClick event to handle Save btn.
 * @param onCancelBtn OnClick event to handle Cancel btn.
 * @returns a section of pens for Freeda Location Feeder systems.
 */
export default function SECTION_EDIT({ sectionId, onSaveBtn, onCancelBtn, pens }: Section_Props) {
  const {t} = useTranslation()
  const [animalsToEdit, setAnimalsToEdit] = useState<number[]>([]);
  const [checkedPens, setCheckedPens] = useState<number[]>([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const dirtRef = useRef<PanelMaintainAnimal[]>([]);
  console.log(dirtRef.current);

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { data: animalsState, maintainEntries: updateAnimals } =
    useAnimal(connection);
    const { call: getLfSectionsInfo } = useSection(connection);
  

  const animals = pens.flatMap((pen) => pen.animals);
  function CancelBtnClick() {
    dirtRef.current = [];
    if (onCancelBtn) onCancelBtn()
  }
  
  // console.log("data:", dirtRef.current)

  function SaveBtnClick() {
    if (onSaveBtn) onSaveBtn()
    if (updateAnimals) {
      updateAnimals({ data: dirtRef.current }, {}, {}, ()=>(getLfSectionsInfo({ ids: [sectionId], idIdentifier: "section_id" }, connection)));
    }
    dirtRef.current = [];
  }

  // Error throwback if no section number excists
  if (!pens.length) {
    return <div>Section {sectionId} not found</div>;
  }

  // Handle checking/unchecking single pens
  // const handlePenCheck = (penId: number, isChecked: boolean) => {
  //   setCheckedPens(prevChecked => {
  //     const updatedPens = isChecked ? [...prevChecked, penId] : prevChecked.filter(p => p !== penId);
      
  //     const newAnimalIds = animals
  //         .filter(animal => updatedPens.includes(animal.location ?? -1))
  //         .map(animal => animal.animalId) || [];

  //     setAnimalsToEdit(newAnimalIds);
  //     return updatedPens;
  //   });
  // };

  // Handle checking/unchecking all pens
  // const handleCheckAllPens = () => {
  //   if (isAllSelected) {
  //     setCheckedPens([]);
  //     setAnimalsToEdit([]);
  //   } else { // if single animal is already checked and "select all" is clicked
  //     const updatedPens = animals
  //       .map(animal => animal.location!) || [];
        
  //     const newAnimalIds = animals
  //       .map(animal => (animal.animalId)) || [];
        
  //     setCheckedPens(updatedPens);
  //     setAnimalsToEdit(newAnimalIds);
  //   }
  //   setIsAllSelected(!isAllSelected);
  // };

  const editModeBtns = 
  <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", width: "100%"}}>
    {/* <Button 
      content={!isAllSelected? t("buttons.selectAll", {defaultValue: "select all"}) : t("buttons.deselectAll", {defaultValue: "deselect all"})} 
      startEnhancer={glyphs.Check({fillColor: colors.systemGreen})} 
      buttonType={ButtonTypes.tableButton} onClick={handleCheckAllPens}
      overrides={{
        baseButton: {backgroundColor: colors.greyLightPrimary},
        hoverStyles: {backgroundColor: colors.greyLightSecondary},
        contentStyles: {color: colors.greyDarkPrimary}
      }}
    />  */}
    <ButtonList 
      contents={[t("buttons.save", {defaultValue: "save"}), t("buttons.cancel", {defaultValue: "cancel"}), t("buttons.add", {defaultValue: "add"}), t("buttons.move", {defaultValue: "move"}), t("buttons.edit", {defaultValue: "edit"})]} 
      onClick={(i => {
        if (i === 0) {SaveBtnClick()} // TODO CTO: Save to db and swith section edit
        else if (i === 1) {CancelBtnClick()}
      })}
      buttonType={ButtonTypes.tableButton}
      startEnhancers={[
        glyphs.Check({fillColor: colors.greyDarkPrimary}), 
        glyphs.Close({fillColor: colors.greyDarkPrimary}),
        glyphs.Add({fillColor: colors.greyDarkPrimary}), 
        glyphs.AnimalMove({fillColor: colors.greyDarkPrimary}), 
        glyphs.Edit({fillColor: colors.greyDarkPrimary})
      ]}
      disabled={[false, false, true, true, true]}
      overrides={(index) => ({
        baseButton: {
          backgroundColor: index === 4 ? colors.greyLightSecondary : colors.greyLightPrimary
        },
        hoverStyles: {
          backgroundColor: colors.greyLightSecondary
        },
        disabledStyles: {
          opacity: index === 4 ? 1 : 0.5
        },
        contentStyles: {
          color: colors.greyDarkPrimary
        }
      })}
    />

  </div>

const renderContent = () =>
  pens.map((pen, index) => (
    <PEN_EDIT
      dirtyDataRef = {dirtRef}
      key={pen.location_id}
      pen={pen}
      penType={penTypes.advanced}
      // onCheck={(isChecked) => handlePenCheck(pen.location_id, isChecked)}
      // isChecked={checkedPens.includes(pen.location_id)}
      borderRadius={{
        borderRadius:
          index === 0
            ? "10px 10px 0px 0px"
            : index === pens.length - 1
            ? "0px 0px 10px 10px"
            : "0px",
      }}
    />
  ));

  return (
      <div style={{ width: "fit-content", height: "fit-content" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "end", padding: "0px 20px" }}>
          {editModeBtns}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "", width: "fit-content", gap: "10px", borderRadius: "10px" }}>
          {renderContent()}
        </div>
      </div>
  );
}